export default {
  onboarding: {
    actions: {
      mainBlue: 'Commencer'
    }
  },
  details: {
    stepTitle: 'Informations sur le sinistre',
    aboutProperty: 'Informations complémentaires',
    title: 'Détails du bien endommagé: ',
    errorMsgInputTxt: 'Champs obligatoire',
    errorMsgGeneral: 'Vérifiez le formulaire avant de continuer',
    errorImages: 'Veuillez ajouter des photos avant de continuer',
    warningMsg: 'Si ces informations sont incomplètes ou erronées, nous vous invitons à vous rapprocher de votre interlocuteur Allianz habituel.',
    address: {
      literal: 'Adresse',
      placeholder: 'Entrer un lieu'
    },
    zipCode: {
      literal: 'Code postal'
    },
    propertyType: {
      literal: 'Type de propriété',
      options: {
        appartment: 'Appartement',
        maison: 'Maison',
        local_commercial: 'Local commercial'
      }
    },
    residentType: {
      literal: 'Type de résident',
      options: {
        propietarie: 'Propriétaire',
        locataire: 'Locataire',
        propietarie_non_occupant: 'Propriétaire Non Occupant'
      }
    },
    moreThanTwoYears: {
      literal: 'Age de l’immeuble',
      options: {
        less: 'Moins de 2 ans',
        more: 'Plus de 2 ans'
      }
    },
    observations: {
      literal: 'Observations'
    },
    map: {
      empty: {
        title: 'Sans adresse',
        text: 'Veuillez saisir une adresse valide'
      }
    },
    textArea: {
      placeHolder: 'Longueur du texte limitée à 255 caractères maximum'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Continuer avec les dommages aux meubles'
    }
  },
  compensationType: {
    title: 'Pour vos dommages immobiliers, quelle solution préférez-vous ?',
    subtitle: 'Concernant vos dommages immobiliers ',
    propertyDamage: 'Dommages immobiliers déclarés',
    text: 'Nous vous proposons trois solutions possibles:',
    recommended: 'Choisissez la solution d’indemnisation que vous préférez',
    amount: "Base d'indemnisation de :",
    e2eCompensations: {
      ourRecommendation: 'Notre recommandation',
      gagDetail: {
        title: 'Réaliser les travaux moi-même',
        text: 'Recevez l’indemnisation immédiate ci-dessous vous permettant de réaliser les travaux en toute autonomie pour la remise en état de vos biens à l\'identique.',
        link: 'Choisir cette solution'
      },
      billma: {
        title: 'Choisir mon propre professionnel',
        text: 'Joignez le devis du professionnel de votre choix afin de recevoir votre indemnisation.',
        link: 'Choisir cette solution'
      },
      renDetail: {
        title: 'Choisir un professionnel agrée Allianz',
        text: 'Choisissez un créneau qui vous convient pour réaliser les travaux et profitez de réparations de qualité sans aucune démarche administrative, seule une éventuelle franchise pourra rester à votre charge.',
        text2: 'Pas de gestion et uniquement la franchise à payer.',
        link: 'Choisir cette solution'
      }
    }
  },
  compensationMobilier: {
    title: 'Dommages mobiliers',
    subtitle: 'Montant de l’indemnité',
    total: 'Total:',
    totalAmount: 'Total indemnisation',
    actions: {
      primary: 'Oui, j’accepte l’indemnisation proposée',
      secondary: 'Je souhaite parler avec un conseiller'
    }
  }
}
